/* @flow strict */

import * as React from 'react';
// import _ from 'lodash';
import Modal from '/client/src/components/Modal';
import Loader from '/client/src/components/Loader';
import { currency } from '/client/src/constants/';
import { format } from '/client/src/utils/amountTransformation';
import { convertToLocalTime } from '/client/src/utils/jstz';

import './styles.scss';
import moment from 'moment';

type PropsType = {
  isOpen: boolean,
  handleShowPaymentModal: (boolean) => void,
  showPaymentModalOrderId: null | number | string,
  eventData?: any
};

class EventPageDetailCustomersPaymentModal extends React.Component<PropsType> {
  state = {
    data: null
  }

  handleClose = (): any => {
    const { handleShowPaymentModal } = this.props;

    handleShowPaymentModal(false);
  };

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      this.setState({
        data: _.get(response, 'data.result', [])
      });
    }
  }

  render(): React.Element {
    const { isOpen, showPaymentModalOrderId, eventData } = this.props;
    const { data } = this.state;

    return (
      <Modal
        altView
        isScrollable
        opened={isOpen}
        onClose={this.handleClose}
      >
        <div className="modal-dialog modal-lg customModal EventPageDetailCustomersModal modal-table-filter" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span className="icon icon-ticket modal-icon modal-icon-pink" style={{ marginRight: '2rem' }} />
                <span>Payment Summary</span>
              </h4>
            </div>
            <div className="modal-body" style={{ paddingBottom: '0', minHeight: 200 }}>
              <Loader
                url={`/api/v1/1/orders/${showPaymentModalOrderId}`}
                onLoaded={this.handleLoaded}
              >
                {data &&
                  <>
                  <table className="table table-default">
                    <tbody>
                      <tr className="even">
                        <td className="col-xs-2">
                          <span data-bind="i18n:$L.purchaser">Purchaser</span>:&nbsp;
                        </td>
                        <td>{data.customer_first_name} {data.customer_last_name}</td>
                      </tr>

                      <tr>
                        <td><span data-bind="i18n:$L.email">Email</span>:</td>
                        <td data-bind="text:email">{data.customer_email_address}</td>
                      </tr>

                      <tr className="even">
                        <td><span>Phone</span>:</td>
                        <td data-bind="text:phone">{data.customer_phone_number}</td>
                      </tr>

                      <tr>
                        <td><span lang-key="manage.refund_page.date_purchased">Date Purchased</span>:</td>
                        <td data-bind="text:datePurchased">
                          {convertToLocalTime(_.get(data, 'creation_time', ''), eventData.time_zone_id, 'MM/DD/YY h:mm a z')}
                        </td>
                      </tr>

                      <tr className="even">
                        <td><span lang-key="manage.refund_page.total_payment">Total Payment</span>:</td>
                        <td data-bind="$money:totalPayment,$symbol:currency">
                          {format(currency[data.currency], data.amount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ overflow: 'auto' }}>
                  {!!_.size(data.attendees) &&
                      <table className="table table-default">
                        <thead>
                          <tr className="no-bg">
                            <th>Guests</th>
                            <th>Ticket Type</th>
                            <th>Ticket Value</th>
                            <th>Last 4 CC</th>
                            <th>Refunded</th>
                            <th>Ticket Status</th>
                          </tr>
                        </thead>
                        <tbody data-bind="foreach:attendees">
                          {_.map(data.attendees, (at: {}, ati: number): React.Element<'tr'> => {
                            return (
                              <tr
                                key={`EventPageDetailCustomersPaymentModal-attendees-${ati}`}
                                className={ati % 2 === 0 ? 'even' : 'odd'}
                              >
                                <td data-bind="text:attendee_name">{at.first_name} {at.last_name}</td>
                                <td data-bind="text:ticket_name">{at.ticket.name}</td>
                                <td data-bind="$money:merchant_revenue,$symbol:$parent.currency">
                                  {format(currency[data.currency], at.ticket.merchant_revenue)}
                                </td>
                                <td data-bind="text:card_last4">{at.order.card_last4}</td>
                                <td data-bind="$money:refunded,$symbol:$parent.currency">
                                  {format(currency[data.currency], at.refund_amount)}
                                </td>
                                <td data-bind="text:ticket_status">{at.has_voided ? 'void' : 'valid'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                  }
                  {!!_.size(data.order_donation_items) &&
                        <div style={{ overflow: 'auto' }}>
                          <table className="table table-default">
                            <thead>
                              <tr className="no-bg" style={{ fontWeight: 'bold' }}>
                                <th>Donation Name</th>
                                <th>Donation Amount</th>
                                <th>CC Fee</th>
                                <th style={{ width: '100px' }}>Refunded</th>
                              </tr>
                            </thead>
                            <tbody>
                              {_.map(data.order_donation_items, (d: {}, i: number): React.Element<'tr'> => {
                                return (
                                  <tr
                                    key={`EventPageDetailCustomersPaymentModal-donations-${i}`}
                                    className={i % 2 === 0 ? 'even' : 'odd'}
                                  >
                                    <td>{d.donation_snapshot.name}</td>
                                    <td> {format(currency[data.currency], d.amount)}</td>
                                    <td> {format(currency[data.currency], d.total_fee)}</td>
                                    <td> {format(currency[data.currency], d.refund_amount)}</td>
                                  </tr>
                                );
                              })
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                  </div>
                  </>
                }
              </Loader>
            </div>
            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Close</button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageDetailCustomersPaymentModal;
